import { useState } from "react"
import { useParams } from "react-router-dom";
import { Spinner } from "@nextui-org/react";

import Fileponds from "@/components/filepond/Filepond"
import Input from '@/components/input/Input';
import Button from '@/components/Button';

import useUpdateMaterial from "../hooks/useUpdateMaterial";

function UpdateMaterial({ onCloseModal, oldMaterial }) {
    const { lectureId, courseId } = useParams()
    const [material, setMaterial] = useState(null)
    const [name, setName] = useState(oldMaterial?.attributes?.name)
    const [brief, setBrief] = useState(oldMaterial?.attributes?.brief)

    const { updateMaterial, isUpdating, error } = useUpdateMaterial()

    function onSubmit() {
        if (name || material?.[0]?.serverId || brief) {
            updateMaterial({ lectureId, courseId, name, brief, file: material[0]?.serverId, materialId: oldMaterial?.id }, {
                onSuccess: () => {
                    setBrief('')
                    setName('')
                    setMaterial('')
                    onCloseModal?.()
                }
            })
        }
    }

    return (
        <div className="flex flex-col justify-center gap-5 w-full md:w-[600px] pt-5">
            <Input label='الأسم' edit={true} type="text" name='name' disabled={isUpdating}
                error={error?.response?.data?.errors?.name?.[0]} size="fullWidth" value={name} onChange={(e) => setName(e.target.value)} />

            <Input label='الوصف' edit={true} type="text" name='brief' disabled={isUpdating}
                error={error?.response?.data?.errors?.brief?.[0]} size="fullWidth" value={brief} onChange={(e) => setBrief(e.target.value)} />

            <p>تعديل الملف:</p>
            <Fileponds filePath='images/questions/' imageToken={setMaterial} />
            <div className="w-full py-3">
                <Button
                    type="primary"
                    className="flex items-center justify-center w-full leading-8"
                    disabled={isUpdating}
                    onClick={onSubmit}
                >
                    {isUpdating ? <Spinner color="white" /> : "تعديل"}
                </Button>
            </div>
        </div>
    )
}

export default UpdateMaterial